
// TODO: REMOVE - DEPRECATED

"use client";
import { useWebSocketContext } from "@/utils/providers/websocket";
import React, { createContext, useContext, useEffect, useState } from "react";

interface GameRoomContextType {
  gameData: any;
}

const GameRoomContext = createContext<GameRoomContextType | undefined>(undefined);

export const useGameRoom = () => {
  const context = useContext(GameRoomContext);
  if (!context) {
    throw new Error("useGameRoom must be used within a GameRoomProvider");
  }
  return context;
};

interface GameRoomProviderProps {
  gameId: number;
  children: React.ReactNode;
}

export const GameRoomProvider: React.FC<GameRoomProviderProps> = ({ gameId, children }) => {
  const { data, socket, isConnected } = useWebSocketContext();
  const [gameData, setGameData] = useState<any | null>(null);

  useEffect(() => {
    if (isConnected && socket) {
      const subscribeMessage = JSON.stringify({ type: "subscribe", room: "game", data: [String(gameId)]});
      socket.send(subscribeMessage);
      console.log(`Subscribed to game room: ${gameId}`);
    }

    return () => {
      if (socket) {
        const unsubscribeMessage = JSON.stringify({ type: "unsubscribe", room: "game", data: [String(gameId)]});
        socket.send(unsubscribeMessage);
        console.log(`Unsubscribed from game room: ${gameId}`);
      }
    };
  }, [isConnected, socket, gameId]);

  useEffect(() => {
    if (data && data.room === `${gameId}`) {
      console.log("Received update for game room:", data);
      setGameData(data);
    }
  }, [data, gameId]);

  return (
    <GameRoomContext.Provider value={{ gameData }}>
      {children}
    </GameRoomContext.Provider>
  );
};
